/* eslint-disable node/no-unpublished-import, node/no-unsupported-features/es-syntax, import/extensions */
import Avatar from '../src/avatar.js';

export default Avatar;
